import {UserContextService} from './application/app-context/user-context/user-context.service';
import {UserContext} from './application/app-context/user-context/user-context';
import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {map} from 'rxjs/operators';
import {AmplitudeService} from './application/analytics/service/amplitude.service';
import {environment} from '../environments/environment';

declare function activateHeader(accountId: any, locale: any): any;

@Component({
             selector: 'app-root',
             templateUrl: './app.component.html',
             styleUrls: ['./app.component.scss']
           })
export class AppComponent implements OnInit {

  userContextIsInitialized = false;

  constructor(private userContextService: UserContextService,
              private translateService: TranslateService,
              private amplitudeService: AmplitudeService) {
  }

  private static activateHeader(userContext: UserContext): UserContext {
    if ('undefined' !== typeof userContext) {
      activateHeader(userContext.accountId, userContext.locale);
    }
    return userContext;
  }

  ngOnInit(): void {
    this.userContextService.initUserContextFromLoggedUser()
        .pipe(
          map((userContext: UserContext) => this.initTranslateService(userContext)),
          map((userContext: UserContext) => AppComponent.activateHeader(userContext)),
          map((userContext: UserContext) => this.initAmplitude(userContext))
        ).subscribe(() => this.userContextIsInitialized = true);

  }

  private initTranslateService(userContext: UserContext): UserContext {
    this.translateService.use(userContext.locale);
    return userContext;
  }

  private initAmplitude(userContext: UserContext): void {
    this.amplitudeService.init(userContext);
  }
}
